module.exports = __webpack_public_path__ + "img/espresso_martini.6308d385.jpg";